import { useQuery } from "react-query";
import {
  CustomButton2,
  CustomModal,
  CustomRadioButtonGroup,
  CustomView,
} from "../../../../../../components";
import Context from "../../../../../../context";
import api from "../../../../../../api";
import React, { useState } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import {
  OFFLINE_PAYER_WAY,
  STATUS_PAY_TO_DRIVER,
} from "../../../../../../values/dropdownItems";
import { IItem } from "../../../../../../types/common.interface";
import successHandler from "../../../../../../utils/successHandler";

const SendToBankPayToDriver = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const {
    showModal,
    setShowModal,
    selectedDebt,
    setSelectedWithdrawal,
    getAllDebt,
  } = React.useContext(Context.payAdminToDriverContext);

  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmitHandler = async () => {
    setLoading(true)
    let result = await api.put.administrator.sendToBankPayToDriver({
      withdrawalId: selectedDebt._id,
    });
    console.log(result);
    if (result.CODE === 2213) {
      setShowModal("NONE");
      successHandler(2010);
      setSelectedWithdrawal([]);
      getAllDebt.refetch();
    }
    setLoading(false)

  };


  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <CustomModal
      onClose={() => {
        setShowModal!("NONE");
        // setFormData({});
        // setStep(1);
      }}
      open={showModal === "SEND_TO_BANK_PAY_TO_DRIVER"}
      // minWidth={"40vw"}
      maxWidth={"45vw"}
      maxHeight={"30vh"}
    >
      <>
        <h6>{t("changeStatus")}</h6>
        <div style={{ width: "100%", marginTop: "2rem" }}>
          <CustomView.Row className="form-column-row">
            <div className="message-row">
              {" "} شما درحال تغییر وضعیت پرداخت به "ارسال به بانک" برای راننده
              <strong>
                {" "}
                {selectedDebt?.driver?.firstName +
                  " " +
                  selectedDebt?.driver?.lastName}
              </strong>{" "}
              <span>هستید</span>
            </div>
          </CustomView.Row>
          <div style={{ width: "100%", marginTop: "2rem" }}>
            <CustomView.Row className="form-column-row">
              <CustomButton2 title={t("submit")} onClick={onSubmitHandler} isLoading={loading} />
            </CustomView.Row>
          </div>
        </div>
      </>
    </CustomModal>
  );
};

export default SendToBankPayToDriver;
